/// <reference path="../../typings/browser.d.ts" />
// /// <reference path="../../customtypings/ng-device-detector/ng-device-detector.d.ts" />

namespace Application.Controllers {
  'use strict';

  import IBlock = Models.IBlock;
  import IRedundantBlock = Models.IRedundantBlock;

  /**
   * RedundantBlocksController class
   */

  export class RedundantBlocksController {
    public static $name: string = 'redundantBlocksController';
    public static $inject: string[] = [
      '$http',
      '$window',
      'ModalService',
      'blockService',
      'streamPipeService'
    ];

    public searchText: string = '';
    public redundantBlocks: IRedundantBlock[] = [];
    public myClonedArray: IRedundantBlock[] = [];
    public allBlocks: IBlock[];

    /**
     * Constructor
     */
    constructor(
      private $http: ng.IHttpService,
      private $window: ng.IWindowService,
      private modalService: ngModal.IModalService,
      private blockService: Services.BlockService,
      private streamPipeService: Services.StreamPipeService
    ) {
      this.initData();
    }

    /**
     * Initiliaze data. Get all blocks and filter them to only get VTS
     *  and only one block of each redundancy with all the info
     */
    private initData(): void {
      //list of all redundant blocks to show in the view
      this.redundantBlocks = [];
      this.blockService.getAllBlocksPromise().then((blocks: IBlock[]) => {
        this.allBlocks = blocks;
        blocks = blocks
          .filter((block: IBlock) => {
            return (
              block.blockTypeNaturalKey == 'V_TS' &&
              block.config.redundancyGroup
            );
          })
          .filter((block: IBlock, index, self) => {
            return (
              index ==
              this.findRedundancyGroupIndex(
                block.config.redundancyGroup.redundancyIds,
                self
              )
            );
          });
        this.mapRedundantBlocks(blocks);
      });
    }

    /**
     *
     * @param redundancyIds ids to find in array
     * @param self array containing all block objects
     */
    public findRedundancyGroupIndex(redundancyIds: string, self: IBlock[]) {
      for (let index = 0; index < self.length; index++) {
        if (self[index].config.redundancyGroup.redundancyIds == redundancyIds) {
          return index;
        }
      }
    }

    /**
     *
     * @param redundancyIds remove redundancyGroup key from block object
     * and update block.
     * Update view after removing redundancy
     */
    public async removeRedundancy(redundancyIds: string) {
      if( await this.streamPipeService.isInUse(redundancyIds)){
        this.showErrorModal();
      }
      else {
        this.showConfirmModal(redundancyIds);
      }
    }

    public showErrorModal() {
      this.modalService.showModal({
        templateUrl: Controllers.InfoModalController.templateURL,
        controller: Controllers.InfoModalController.$name,
        inputs: {
            title: 'ERROR',
            description: 'Redundancy cannot be deleted. Stop every transmission using these blocks and try again.',
        },
    }).then((modal: ngModal.IModalObject) => {
        let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.InfoModalController.ID,
            {bgclose: false, modal: false, keyboard: false});
        modalElem.show();
        modal.close.then((result: Object) => {
            modalElem.hide();
        });
    });
    }

    public showConfirmModal(redundancyIds: string) {
      this.modalService.showModal({
        templateUrl: Controllers.ConfirmModalController.templateURL,
        controller: Controllers.ConfirmModalController.$name,
        inputs: {
          title: 'DELETE REDUNDANT LINK',
          description: "The link between these redundant blocks will be deleted and won't be available anymore",
          name: '',
          type: 'warning',
        },
      }).then((modal: ngModal.IModalObject) => {
        let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.ConfirmModalController.ID,
            {bgclose: false, modal: false, keyboard: false});
        modalElem.show();
        modal.close.then((result: string) => {
          modalElem.hide();
          if (result) {
            this.allBlocks.forEach((block: IBlock) => {
              if (block.config.redundancyGroup) {
                if (block.config.redundancyGroup.redundancyIds == redundancyIds) {
                  delete block.config.redundancyGroup;
                  this.blockService.updateBlock(block).then(data => {
                    this.redundantBlocks = this.redundantBlocks.filter(blocky => {
                      return blocky.block.id != block.id;
                    });
                  });
                }
              }
            });
          }
        });
      });
    }

    /**
     * populates redundantBlocks array to display it in the table view
     * @param blocks blocks from database to map in order to display them
     * as redundant blocks
     */
    public mapRedundantBlocks(blocks: IBlock[]) {
      blocks.map((block: IBlock) => {
        this.redundantBlocks.push({
          name: block.config.redundancyGroup.name,
          primary: block.config.redundancyGroup.primary,
          redundant: block.config.redundancyGroup.redundant,
          block: block
        });
        this.myClonedArray = (<any>Object).assign([], this.redundantBlocks);
      });
    }
    /**
     * open modal to create new redundancy
     */
    public createRedundancy() {
      this.modalService
        .showModal({
          templateUrl:
            Application.Controllers.RedundantBlocksModalController.templateURL,
          controller:
            Application.Controllers.RedundantBlocksModalController.$name,
          inputs: {
            redundantBlocks: this.redundantBlocks
          }
        })
        .then((modal: ngModal.IModalObject) => {
          let modalElem: UIkit.ModalElement = UIkit.modal(
            Application.Controllers.RedundantBlocksModalController.ID,
            { bgclose: false, modal: false, keyboard: false }
          );
          modalElem.show();
          modal.close.then(() => {
            modalElem.hide();
            this.initData();
          });
        });
    }

    /**
     * filter by text. A cloned array of the complete redundancy blocks is used
     * to restore default list after filtering the redundancyBlocks array to display
     * specific results in the view.
     */
    public searchAsType() {
      if (this.searchText == '') this.redundantBlocks = this.myClonedArray;
      this.redundantBlocks = this.myClonedArray.filter(
        (block: IRedundantBlock) => {
          return block.name.indexOf(this.searchText) != -1;
        }
      );
    }
  }
}
